export const productStatuses = {
  LIVE: "Live",
  BETA: "Beta",
  BUILDING: "Building",
  PLANNED: "Planned"
};

export const products = [
  {
    id: "gradevit",
    logo: "GV",
    name: "GradeVIT",
    description: "Academic resources, GPA tools, notes, and utilities built for VIT students.",
    status: productStatuses.LIVE,
    category: "Student Platform",
    link: "https://gradevit.technie.in",
    featured: true
  },
  {
    id: "ai-products",
    logo: "AI",
    name: "AI Products",
    description: "Practical AI utilities designed for focused, everyday workflows.",
    status: productStatuses.PLANNED,
    category: "AI Tools",
    link: "#",
    featured: false
  },
  {
    id: "mobile-apps",
    logo: "MA",
    name: "Mobile Apps",
    description: "Small, polished applications for students, professionals, and daily use.",
    status: productStatuses.BUILDING,
    category: "Mobile Applications",
    link: "#",
    featured: false
  },
  {
    id: "saas-platforms",
    logo: "SP",
    name: "SaaS Platforms",
    description: "Future-ready web products for teams, creators, and niche operators.",
    status: productStatuses.PLANNED,
    category: "SaaS Products",
    link: "#",
    featured: false
  },
  {
    id: "developer-tools",
    logo: "DT",
    name: "Developer Tools",
    description: "Utilities that reduce repetitive work and make technical workflows clearer.",
    status: productStatuses.PLANNED,
    category: "Developer Tools",
    link: "#",
    featured: false
  }
];
